import React, { useState } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Stack,
  IconButton,
  Dialog,
  DialogContent,
  Slide,
  Divider,
  Chip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useTheme, // 👈 Ajoutez ceci
  useMediaQuery, // 👈 Ajoutez ceci
} from '@mui/material';
import {
  PlayCircleFilled,
  CheckCircle,
  Close,
  Visibility,
  Stars,
  CalendarToday,
  Lock,
  LockOpen,
  MoreVert,
  Edit,
  Delete,
} from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const VideoCard = ({ video, onUpdate, onDelete }) => {
  const [open, setOpen] = useState(false);
  // ✅ AJOUT DES ÉTATS POUR LE MENU
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const theme = useTheme();
  // Détecte si on est sur mobile ou si la fenêtre est petite
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // ✅ FONCTIONS POUR LE MENU
  const handleMenuClick = (event) => {
    event.stopPropagation(); // Empêche d'ouvrir la vidéo
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (e) => {
    if (e) e.stopPropagation();
    setAnchorEl(null);
  };

  const handleAction = (type) => {
    handleMenuClose();
    if (type === 'update' && onUpdate) onUpdate(video);
    if (type === 'delete' && onDelete) onDelete(video.id_video_lbrv);
  };

  const getRelativeTime = (dateString) => {
    if (!dateString) return '';
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    const units = [
      { label: 'an', seconds: 31536000 },
      { label: 'mois', seconds: 2592000 },
      { label: 'semaine', seconds: 604800 },
      { label: 'jour', seconds: 86400 },
      { label: 'heure', seconds: 3600 },
      { label: 'minute', seconds: 60 },
      { label: 'seconde', seconds: 1 },
    ];

    for (let unit of units) {
      const interval = Math.floor(diffInSeconds / unit.seconds);
      if (interval >= 1) {
        return `il y a ${interval} ${unit.label}${interval > 1 && unit.label !== 'mois' ? 's' : ''}`;
      }
    }
    return "à l'instant";
  };

  const STORAGE_URL = `${process.env.REACT_APP_API_URL}/storage/workshop/`;

  const getYouTubeId = (url) => {
    if (!url) return null;
    const regExp =
      /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^#&?]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  const videoId = getYouTubeId(video.file_name_lbrv);
  const isYouTube = Boolean(videoId);

  const thumbnailUrl = isYouTube
    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    : `${video.file_name_lbrv}#t=0.5`;

  const embedUrl = isYouTube
    ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`
    : null;

  return (
    <>
      <Box
        onClick={() => setOpen(true)}
        sx={{
          cursor: 'pointer',
          width: '100%',
          minWidth: '326px',
          transition: 'all 0.3s ease',
          '&:hover': { transform: 'translateY(-8px)' },
          '&:hover .play-overlay': { opacity: 1 },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            aspectRatio: '16/9',
            borderRadius: '24px',
            overflow: 'hidden',
            bgcolor: '#000',
          }}
        >
          {video.unlocks_tokens > 0 && (
            <Chip
              icon={
                <Stars sx={{ color: '#FFD700 !important', fontSize: '14px' }} />
              }
              label={`${video.unlocks_tokens} Jetons`}
              sx={{
                position: 'absolute',
                top: 12,
                left: 12,
                zIndex: 3,
                bgcolor: 'rgba(0,0,0,0.6)',
                color: '#fff',
                fontSize: '11px',
                fontWeight: 700,
              }}
            />
          )}
          {/* BADGE STATUT PAYANT/GRATUIT (Haut Droite) */}
          <Chip
            icon={
              video.is_paid_video_lbrv === 1 ? (
                <Lock
                  sx={{ fontSize: '14px !important', color: '#fff !important' }}
                />
              ) : (
                <LockOpen
                  sx={{ fontSize: '14px !important', color: '#fff !important' }}
                />
              )
            }
            label={video.is_paid_video_lbrv === 1 ? 'PREMIUM' : 'GRATUIT'}
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 3,
              bgcolor:
                video.is_paid_video_lbrv === 1
                  ? 'rgba(67, 24, 255, 0.85)'
                  : 'rgba(1, 181, 116, 0.85)',
              color: '#fff',
              fontSize: '10px',
              fontWeight: 900,
              backdropFilter: 'blur(4px)',
              border: 'none',
            }}
          />
          <Box
            component={isYouTube ? 'img' : 'video'}
            src={thumbnailUrl}
            sx={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />

          <Box
            className="play-overlay"
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0,
              transition: '0.3s',
              bgcolor: 'rgba(0,0,0,0.3)',
            }}
          >
            <PlayCircleFilled sx={{ color: '#fff', fontSize: 70 }} />
          </Box>
        </Box>

        <Stack direction="row" spacing={2} sx={{ mt: 2, px: 1 }}>
          <Avatar
            src={
              video.user?.photo_user
                ? `${STORAGE_URL}${video.user.photo_user}`
                : ''
            }
            sx={{ bgcolor: '#4318FF', fontWeight: 800 }}
          >
            {video.user?.prenom_user?.[0]?.toUpperCase()}
          </Avatar>
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontWeight: 800,
                color: '#1B2559',
                fontSize: '15px',
                height: '40px', // Garde une hauteur fixe pour l'alignement
                lineHeight: '20px',
              }}
            >
              {video.name_video_lbrv?.length > 27
                ? `${video.name_video_lbrv.substring(0, 27)}...`
                : video.name_video_lbrv}
              {/* ✅ BOUTON 3 POINTS */}
              <IconButton size="small" onClick={handleMenuClick}>
                <MoreVert sx={{ fontSize: '20px', color: '#A3AED0' }} />
              </IconButton>
            </Typography>

            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: '13px', color: '#A3AED0' }}>
                {video.user?.prenom_user} {video.user?.nom_user}{' '}
                <CheckCircle sx={{ fontSize: 12, color: '#4318FF' }} />
              </Typography>
              <Box
                sx={{
                  width: 3,
                  height: 3,
                  bgcolor: '#CBD5E0',
                  borderRadius: '50%',
                }}
              />
              <Typography
                sx={{
                  fontSize: '12px',
                  color: '#A3AED0',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {video.number_views_video_lbrv} vues
              </Typography>
              <Box
                sx={{
                  width: 3,
                  height: 3,
                  bgcolor: '#CBD5E0',
                  borderRadius: '50%',
                }}
              />
              <Typography sx={{ fontSize: '12px', color: '#A3AED0' }}>
                {getRelativeTime(video.created_at)}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Box>
      {/* MENU OPTIONS */}
      {/* ✅ COMPOSANT MENU */}
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        PaperProps={{ sx: { borderRadius: '12px' } }}
      >
        <MenuItem onClick={() => handleAction('update')}>
          <ListItemIcon>
            <Edit fontSize="small" sx={{ color: '#4318FF' }} />
          </ListItemIcon>
          <ListItemText>Modifier</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAction('delete')}>
          <ListItemIcon>
            <Delete fontSize="small" sx={{ color: '#FF5B5C' }} />
          </ListItemIcon>
          <ListItemText sx={{ color: '#FF5B5C' }}>Supprimer</ListItemText>
        </MenuItem>
      </Menu>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        TransitionComponent={Transition}
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : '28px',
            bgcolor: '#FFFFFF',
            boxShadow: '0px 40px 80px rgba(0, 0, 0, 0.12)', // Ombre douce et profonde
            overflow: 'hidden',
          },
        }}
      >
        {/* ================= 1. PLAYER SECTION ================= */}
        <Box
          sx={{
            position: 'relative',
            bgcolor: '#050505',
            width: '100%',
            aspectRatio: '16 / 9',
            lineHeight: 0,
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              zIndex: 20,
              color: '#fff',
              bgcolor: 'rgba(255,255,255,0.15)',
              backdropFilter: 'blur(12px)', // Effet frosted glass
              '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
            }}
          >
            <Close sx={{ fontSize: 18 }} />
          </IconButton>

          {isYouTube ? (
            <iframe
              title="Lecteur vidéo"
              width="100%"
              height="100%"
              src={open ? `${embedUrl}?autoplay=1` : ''}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{ border: 0 }}
            />
          ) : (
            <Box
              component="video"
              src={video.file_name_lbrv}
              controls
              sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          )}
        </Box>

        {/* ================= 2. CONTENT SECTION ================= */}
        <DialogContent sx={{ p: { xs: 3, md: 5 }, bgcolor: '#FFFFFF' }}>
          {/* TITRE ÉLÉGANT */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              color: '#1B2559',
              letterSpacing: '-0.02em',
              mb: 3,
              lineHeight: 1.2,
            }}
          >
            {video.name_video_lbrv}
          </Typography>

          {/* BARRE D'INFOS (YouTube Style) */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
            spacing={2}
          >
            {/* CÔTÉ GAUCHE : PROFIL */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar
                src={
                  video.user?.photo_user
                    ? `${STORAGE_URL}${video.user.photo_user}`
                    : ''
                }
                sx={{
                  width: 44,
                  height: 44,
                  border: '2px solid #F4F7FE',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                }}
              />
              <Box>
                <Typography
                  sx={{ fontWeight: 700, color: '#1B2559', fontSize: '1rem' }}
                >
                  {video.user?.prenom_user} {video.user?.nom_user}
                </Typography>
                <Typography
                  sx={{
                    color: '#A3AED0',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                  }}
                >
                  Créateur vérifié
                </Typography>
              </Box>
            </Stack>

            {/* CÔTÉ DROIT : STATS & BADGE */}
            {/* CÔTÉ DROIT : STATS & BADGE */}
            <Stack
              direction="row"
              spacing={2.5}
              alignItems="center"
              sx={{
                bgcolor: '#F4F7FE',
                px: 2.5,
                py: 1,
                borderRadius: '16px',
                width: { xs: '100%', sm: 'auto' },
                justifyContent: 'center',
              }}
            >
              {/* VUES */}
              <Stack
                direction="row"
                spacing={0.8}
                alignItems="center"
                sx={{ color: '#47548C' }}
              >
                <Visibility sx={{ fontSize: 18, opacity: 0.7 }} />
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 700 }}>
                  {video.number_views_video_lbrv?.toLocaleString()}
                </Typography>
              </Stack>

              {/* DATE */}
              <Stack
                direction="row"
                spacing={0.8}
                alignItems="center"
                sx={{ color: '#47548C' }}
              >
                <CalendarToday sx={{ fontSize: 16, opacity: 0.7 }} />
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 700 }}>
                  {new Date(video.created_at).toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'short',
                  })}
                </Typography>
              </Stack>

              {/* JETONS (Affiché seulement si > 0) */}
              {video.unlocks_tokens > 0 && (
                <Stack
                  direction="row"
                  spacing={0.8}
                  alignItems="center"
                  sx={{ color: '#E2B133' }}
                >
                  {' '}
                  {/* Couleur Or/Jetons */}
                  <Stars sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: '0.85rem', fontWeight: 800 }}>
                    {video.unlocks_tokens}{' '}
                    {video.unlocks_tokens > 1 ? 'Jetons' : 'Jeton'}
                  </Typography>
                </Stack>
              )}

              {/* BADGE PREMIUM/GRATUIT */}
              <Chip
                label={video.is_paid_video_lbrv === 1 ? 'PREMIUM' : 'GRATUIT'}
                sx={{
                  fontWeight: 900,
                  fontSize: '0.65rem',
                  height: '24px',
                  bgcolor:
                    video.is_paid_video_lbrv === 1 ? '#4318FF' : '#05CD99',
                  color: '#FFFFFF',
                  boxShadow:
                    video.is_paid_video_lbrv === 1
                      ? '0 4px 14px rgba(67, 24, 255, 0.3)'
                      : '0 4px 14px rgba(5, 205, 153, 0.3)',
                  px: 0.5,
                }}
              />
            </Stack>
          </Stack>

          <Divider sx={{ my: 1, borderColor: '#F4F7FE' }} />

          {/* ZONE DESCRIPTION RAFFINÉE */}
          <Box sx={{ position: 'relative' }}>
            <Typography
              variant="overline"
              sx={{
                color: '#A3AED0',
                fontWeight: 800,
                fontSize: '0.7rem',
                mb: 1,
                display: 'block',
              }}
            >
              Description du contenu
            </Typography>
            <Box
              sx={{
                bgcolor: '#FFFFFF',
                p: 2,
                borderRadius: '16px',
                border: '1px solid #F4F7FE',
                transition: '0.3s',
                '&:hover': { borderColor: '#E9EDF7', bgcolor: '#FAFBFF' },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: '#47548C',
                  //lineHeight: 1.8,
                  //whiteSpace: 'pre-line',
                  fontSize: '0.92rem',
                  fontWeight: 500,
                }}
              >
                {video.description_video_lbrv ||
                  'Aucune description disponible pour ce média.'}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default VideoCard;
